module.exports = __webpack_public_path__ + "img/Loverly_GuestListUserCover.d8e0831.jpg";